const images = {
    avatar: require('@/assets/images/avatar.jpg'),
    noImage: require('@/assets/images/tiktok.jpg'),
    titokCreateImage: require('@/assets/images/titokCreate.png'),
}

export default images;